import React from 'react'
import PropTypes from 'prop-types'

import * as firebase from 'firebase'
import { connect } from 'react-redux'
import CircularProgress from 'material-ui/CircularProgress/CircularProgress'

class PhotoItem extends React.Component {

  static propTypes = {
    disableDeletion: PropTypes.bool,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    storagePath: PropTypes.string.isRequired,
    dbPath: PropTypes.string
  }

  constructor(props) {
    super(props)
    this.state = {
      imageUrl: ''
    }
  }

  componentWillMount(){
    this.getImageURL(this.props.storagePath)
  }

  componentWillReceiveProps(props){
    if (this.props.storagePath !== props.storagePath){
      this.getImageURL(props.storagePath)
    }
  }

  getImageURL = (path) => {
    firebase.storage().ref().child(path)
      .getDownloadURL()
      .then(imageUrl => {
        this.setState({imageUrl})
      })
  }

  handleImageClicked = () => {
    this.props.dispatch({
      type: 'UI_DIALOG',
      label: 'PHOTO_FULL_SCREEN',
      value: {
        imageUrl: this.state.imageUrl,
        imageDBPath: this.props.dbPath,
        disableDeletion: this.props.disableDeletion
      }
    })
  }

  render() {
    if (this.state.imageUrl) {
      return (
        <div style={styles.container}>
          <div style={styles.content}>
            <img
              style={styles.image}
              onClick={this.props.onPress}
              src={this.state.imageUrl}
              width={this.props.width}
              height={this.props.height} />
          </div>
        </div>
      )
    }
    return (
      <div style={styles.progress(this.props.width, this.props.height)}>
        <CircularProgress size={this.props.width/2} thickness={2} color='#527da3' />
      </div>
    )
  }

}

const styles = {

  content: {
    cursor: 'pointer'
  },

  container: {
    marginRight: 6
  },

  image: {
    borderRadius: 3
  },

  progress: (width, height) => ({
    width,
    height,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  })

}

export default connect()(PhotoItem)



// WEBPACK FOOTER //
// ./src/schedule/common/modules/photos/PhotoItem.js